<template>
  <select
    title="Selectionnez un site"
    ref="selectSite"
    name="site"
    id="lieu"
    @change="handleSelectSite"
  >
    <option :value="terrain.name" v-for="terrain in terrains" :key="terrain">
      {{ terrain.description }}
    </option>
  </select>
  <div class="tooltip" id="current">
    <!-- <div>
            {{ this.currentWeather.time }}
        </div> -->
    <span class="tooltiptext">La meteo actuelle sur le site sélectionné</span>
    <div style="padding: 15px; color: magenta">Actuellement</div>
    <div id="thermometre">&#x1f321;{{ currentWeather.temperature_2m }}°</div>
    <div>
      <div id="currentwinddir">
        <!-- affiche une fleche vers le bas qui sera pivotée en js en fonction de la direction du vent -->
        &#x21e9;
      </div>
      <span>({{ currentWeather.wind_direction_10m }}°)</span>
      <div>
        &#x1f32c;{{ currentWeather.wind_speed_10m }}/{{
          currentWeather.wind_gusts_10m
        }}km/h
      </div>
    </div>
    <img :src="currentWeather.picto" alt="mage" />
  </div>
  <div class="menu">
    <button
      class="tooltip"
      @click.stop="
        $emit('showSiteMap', {
          lat: site.lat,
          lon: site.lon,
          code_ffvl: site.code_ffvl,
        })
      "
    >
      <i class="material-icons">map</i
      ><span class="tooltiptext"
        >Click pour voir la position sur une carte</span
      >
    </button>

    <select
      id="previ"
      name="nPrevi"
      size="4"
      @change="handleChangePrevi($event)"
    >
      <option value="1" id="0j">Aujourdh'hui</option>
      <!-- <label for="0j">J</label> -->
      <option value="2" id="1j">Demain</option>
      <option value="3" id="2j">J+2</option>
      <option value="4" id="3j">J+3</option>
    </select>
    <div>
      <input
        ref="filter"
        type="checkbox"
        name="isFav"
        id="isFav"
        title="Cocher pour voir uniquement les valeurs compatibles avec le site sélectionné"
        @click="handleCheck"
      />
      <label for="isFav">favorable only</label>
    </div>
  </div>
  <div id="date">{{ selectedDay }}</div>
  <div class="table">
    <div v-for="(hour, index) in forecast.date_time" :key="index">
      <div class="row-table">
        <p>{{ forecast.date_time[index].heure }}</p>
        <!-- <p>{{ forecast.wind_dir_10m_symbol[index] }}</p> -->
        <Arrow :angle="forecast.wind_direction_10m[index]"></Arrow>
        <p>{{ forecast.wind_direction_10m[index] }}°</p>
        <p>
          {{ forecast.wind_speed_10m[index] }}/{{
            forecast.wind_gusts_10m[index]
          }}
          km/h
        </p>
        <p>{{ forecast.temperature_2m[index] }}°C</p>
        <p><img width="35px" :src="forecast.weather_picto[index]" alt="" /></p>
        <p v-if="!forecast.available[index]">⚠️</p>
        <p v-else></p>
      </div>
    </div>
  </div>
</template>
<script>
import { sectorFromDirection } from "../assets/arrows";
import converDate from "../assets/convertDate";
import code_meteo from "../assets/weather_code";
import terrains from "../assets/terrains";
import Arrow from "./arrow.vue";
//import balisesdatas from '../assets/balises.js'
const completeArray = (array1, array2) => {
  //c les vremplace les null de array1 avec les valeurs de array2
  const transformedArray = array1.map((v, i) => {
    if (v === null) {
      return array2[i];
    }
    return v;
  });
  //console.log("transformed array:",transformedArray);
  return transformedArray;
};
const refDay = (data) => {
  //renvoie le jour formaté correspondant un jeu de donnée(correspond à la date de la première entrée)
  // console.log("appel de refDay")
  try {
    return (
      data.date_time[0].jour_clair +
      " " +
      data.date_time[0].jour +
      " " +
      data.date_time[0].mois_clair
    );
  } catch (err) {
    return "";
  }
};
export default {
  name: "Forecast",
  components: { Arrow },
  props: [],
  emits: ["showSiteMap"],
  data() {
    return {
      name: "nom du site",
      site: terrains[0],
      data: {},
      currentWeather: {},
      previ: 1,
      terrains: terrains,
      isFilterOn: false,
      day: "",
      testangle: 45, //asupprimer
    };
  },
  methods: {
    handleChangePrevi(e) {
      // this.requestforecast = filterForecast(this.forecast, e.target.value)
      this.previ = e.target.value;
    },
    handleCheck() {
      this.isFilterOn = this.$refs.filter.checked;
    },
    handleSelectSite() {
      // this.site=this.$refs.selectSite.value
      this.site = this.terrains.find(
        (value) => value.name == this.$refs.selectSite.value
      );
      this.fetchForecast(this.site, 4).then((data) => {
        this.data = data;
      });
      this.fetchCurrentWeather(this.site).then((data) => {
        this.currentWeather = data;
        //pour tourner la petite fleche dans la direction du vent
        console.warn("rotation", this.data.wind_direction_10m);
      });
    },
    async fetchCurrentWeather(choice_site) {
      const { lat, lon } = choice_site;
      const MODEL = "arome_france_hd";
      const url = `https://api.open-meteo.com/v1/forecast?latitude=${lat}&longitude=${lon}&current=temperature_2m,apparent_temperature,pressure_msl,wind_speed_10m,wind_direction_10m,wind_gusts_10m&timezone=auto&forecast_days=1&models=${MODEL}`;
      const resp = await fetch(url);
      //le modele arome_france_hd ne fournit pas de code méteo alors je vais le chercher sur le modèle best_match(voir api open-meteo)
      const pictoResponse = await fetch(
        "https://api.open-meteo.com/v1/forecast?latitude=44.0412&longitude=5.4035&current=weather_code&timezone=auto&forecast_days=1&models=best_match"
      );
      const currentWeather = await resp.json();
      const picto = await pictoResponse.json();
      currentWeather.current.picto =
        code_meteo[picto.current.weather_code.toString()].day.image;
      document.getElementById(
        "currentwinddir"
      ).style.transform = `rotate(${currentWeather.current.wind_direction_10m}deg)`;
      console.log("current", currentWeather.current);
      return currentWeather.current;
    },
    async fetchForecast(choice_site, dforecast = 1) {
      const LAT = choice_site.lat;
      const LON = choice_site.lon;
      const MODEL = "best_match,arome_france_hd";
      const url = `https://api.open-meteo.com/v1/forecast?latitude=${LAT}&longitude=${LON}&current=temperature_2m,wind_speed_10m,wind_direction_10m,wind_gusts_10m&hourly=temperature_2m,weather_code,wind_speed_10m,wind_direction_10m,wind_gusts_10m&timezone=auto&forecast_days=${dforecast}&models=${MODEL}`;
      const response = await fetch(url);
      const forecast = await response.json();
      console.log("forecast", forecast);

      //prévisions
      const date_time = forecast.hourly.time.map(converDate);
      const wind_speed_10m = completeArray(
        forecast.hourly.wind_speed_10m_arome_france_hd,
        forecast.hourly.wind_speed_10m_best_match
      );
      const wind_direction_10m = completeArray(
        forecast.hourly.wind_direction_10m_arome_france_hd,
        forecast.hourly.wind_direction_10m_best_match
      );
      const wind_gusts_10m = completeArray(
        forecast.hourly.wind_gusts_10m_arome_france_hd,
        forecast.hourly.wind_gusts_10m_best_match
      );
      const weather_code = completeArray(
        forecast.hourly.weather_code_arome_france_hd,
        forecast.hourly.weather_code_best_match
      );
      const weather_description = weather_code.map((value) => {
        //if(value==null){value=0}

        return code_meteo[value.toString()].day.description;
      });
      const weather_picto = weather_code.map((value) => {
        //value=value??0
        return code_meteo[value.toString()].day.image;
      });
      // const wind_dir_10m_symbol = wind_direction_10m.map(arrowFromDirection)
      const wind_dir_10m_sector = wind_direction_10m.map(sectorFromDirection);
      const temperature_2m = forecast.hourly.temperature_2m_best_match;
      const resp = {
        date_time,
        wind_speed_10m,
        wind_gusts_10m,
        wind_direction_10m,
        weather_description,
        weather_picto,
        wind_dir_10m_sector,
        temperature_2m,
      };
      resp.available = [];
      //filtrage des données en fonction des vents compatibles avec le site
      resp.date_time.forEach((value, index) => {
        if (choice_site.secteurs.includes(resp.wind_dir_10m_sector[index])) {
          resp.available.push(true);
        } else {
          resp.available.push(false);
        }
      });
      return resp;
    },
  },
  computed: {
    selectedDay() {
      try {
        // day = this.forecast.date_time[0].jour_clair + ' ' + this.forecast.date_time[0].jour + ' ' + this.forecast.date_time[0].mois_clair
        return refDay(this.forecast);
      } catch (error) {
        console.log("il y a une erreur dans selectedDay", error);
        return refDay(this.data);
      }
    },
    forecast() {
      const filteredForecast = {};
      try {
        for (let key in this.forecastByDay) {
          // console.log(this.forecast.available)
          filteredForecast[key] = this.forecastByDay[key].filter(
            (value, index, array) => {
              return !this.isFilterOn || this.forecastByDay.available[index];
            }
          );
        }

        return filteredForecast;
      } catch (error) {
        console.log("erreur");
        return {};
      }
    },
    forecastByDay() {
      //filtrage des données de this.data pour ne prendre que celles du jour souhaité
      //shift représente la durée de prévision en jour. exemple, 2 signifie previ de demain, 3 apres demain etc ...
      const filteredForecast = {};
      const arrayProps = Object.getOwnPropertyNames(this.data);
      for (let prop of arrayProps) {
        filteredForecast[prop] = this.data[prop].filter((value, index) => {
          return index >= (this.previ - 1) * 24 && index <= this.previ * 24 - 1;
        });
      }
      return filteredForecast;
    },
  },
  mounted() {
    this.fetchForecast(this.site, 4)
      .then((data) => {
        this.data = data;
        // this.day = this.data.date_time[0].jour_clair + ' ' + this.data.date_time[0].jour + ' ' + this.data.date_time[0].mois_clair

        this.fetchCurrentWeather(this.site).then((data) => {
          this.currentWeather = data;
          // console.warn('data au montage', data)
        });
      })
      .catch((err) => console.log(err));
  },
};
</script>
<style>
.row-table {
  display: flex;
  justify-content: space-between;
}

.table div:nth-child(even) {
  background-color: #dbe5e7;
}

.row-table > p {
  width: 10%;
}

.row-table > p:nth-child(4) {
  width: 15%;
}

.row-table > p {
  display: inline-block;
  margin: auto;
  padding: 2px;
}

#date {
  width: 30%;
  text-align: center;
  margin: auto;
  padding: 10px;
  font-size: larger;
  background: rgb(159, 231, 222);
  border-radius: 10px;
}

.menu {
  /* width: 100%; */
  display: grid;
  grid-template-columns: 1fr 6fr 1fr;
  gap: 5px;
  justify-content: space-between;
  border: 1px solid burlywood;
  border-radius: 5px;
  margin-top: 5px;
  margin-bottom: 5px;
  padding: 5px;
}
.menu button {
  background-color: transparent;
  border-radius: 6rem;
  box-shadow: 0.2em 0.2em 0.2em rgb(175, 194, 203);
  border: none;
  width: 6rem;
}
.tooltip {
  position: relative;
  display: inline-block;
}

#current {
  background-color: rgb(5, 32, 96);
  /* width: 30vw; */
  /* margin: auto; */
  display: flex;
  justify-content: center;
  /* width: 40%; */
  margin: auto;
  border-radius: 1em;
  color: white;
}

#current > div {
  margin: 0 1em;
}

#currentwinddir {
  font-size: 2.5em;
  display: inline-block;
}
#currentwinddir ~ div {
  font-size: 1.5em;
}

#thermometre {
  font-size: 2em;
  padding: 1em 0;
}

#lieu {
  /* display: inline-block; */
  width: 98%;
  height: 40px;
  text-align: center;
  background-color: aqua;
  border: 1px solid yellowgreen;
  margin: 5px;
  font-size: 1.2em;
  color: rgb(24, 31, 38);
}
.tooltiptext {
  visibility: hidden;
  background-color: yellow;
  color: black;
  font-size: 1rem;
  border-radius: 5px;
  padding: 3px;
  position: absolute;
  bottom: 100%;
  left: 50%;
  opacity: 0;
  transition: opacity 1s;
  /* z-index:1; */
}
.tooltiptext::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: yellow transparent transparent transparent;
}
.tooltip:hover .tooltiptext {
  visibility: visible;
  opacity: 1;
}
.material-icons {
  font-size: 3rem;
  color: rgb(14, 59, 44);
}
</style>
